import { createEvent, createStore, sample } from 'effector';
import { EventInput } from '@fullcalendar/core';
import { CustomEventClickArg } from './types';

export interface MorePopoverState {
  featureId: string;
  date: Date;
  tasks: EventInput[];
  pos?: { x: number; y: number };
  onTaskClick: (eventInfo: CustomEventClickArg) => void;
  container: HTMLDivElement;
  completeTask: (taskId: string, done: boolean) => void;
}

export const updatePopoverTasksEvent = createEvent<EventInput[]>();
export const setPopoverEvent = createEvent<MorePopoverState | null>();

export const $morePopover = createStore<MorePopoverState | null>(null);

sample({
  source: $morePopover,
  clock: updatePopoverTasksEvent,
  filter: (store: MorePopoverState | null) => store !== null,
  fn: (store: MorePopoverState | null, tasks: EventInput[]) => {
    if (store !== null) {
      return { ...store, tasks };
    }
    return store;
  },
  target: $morePopover,
});

sample({
  clock: setPopoverEvent,
  target: $morePopover,
});
